// directives/debounce.js
export const debounce = {
  inserted(el, binding) {
    const {
      handler,
      delay = 500,
      immediate = true, // 默认立即执行
    } = binding.value || {};

    let timer = null;

    el.addEventListener('click', (...args) => {
      // 如果设置了立即执行且没有计时器存在
      if (immediate && !timer) {
        handler.apply(this, args);
      }

      // 清除之前的计时器
      if (timer) clearTimeout(timer);

      // 设置新的计时器
      timer = setTimeout(() => {
        timer = null;
        // 如果不是立即执行模式，在这里执行
        if (!immediate) {
          handler.apply(this, args);
        }
      }, delay);
    });
  },
};



// WEBPACK FOOTER //
// ./src/directives/index.js